const shallowEqual = (a: any, b: any): boolean => {
  if (a === b) return true
  if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) {
    return false
  }

  // Handle Map
  if (a instanceof Map && b instanceof Map) {
    if (a.size !== b.size) return false
    const keysA = Array.from(a.keys())
    const keysB = Array.from(b.keys())
    for (let i = 0; i < keysA.length; i++) {
      if (keysA[i] !== keysB[i]) return false
      if (a.get(keysA[i]) !== b.get(keysA[i])) return false
    }
    return true
  }

  // Handle Set
  if (a instanceof Set && b instanceof Set) {
    if (a.size !== b.size) return false
    const valsA = Array.from(a)
    const valsB = Array.from(b)
    for (let i = 0; i < valsA.length; i++) {
      if (valsA[i] !== valsB[i]) return false
    }
    return true
  }

  // Handle plain objects and arrays
  const keysA = Object.keys(a)
  const keysB = Object.keys(b)
  if (keysA.length !== keysB.length) return false
  for (let i = 0; i < keysA.length; i++) {
    if (keysA[i] !== keysB[i]) return false
    if (a[keysA[i]] !== b[keysA[i]]) return false
  }

  return true
}

export const createCachedReduxSelector = <T extends (...args: any[]) => any>(selector: T) => {
  let previousValue
  return function (...args: Parameters<T>): ReturnType<T> {
    const newValue = selector(...args)
    if (shallowEqual(previousValue, newValue)) {
      return previousValue
    }
    previousValue = newValue
    return newValue
  } as T
}
